module.exports = __webpack_public_path__ + "static/media/48270258_2308764692532042_1183490217076588544_o.c6b24265.jpg";